export default __webpack_public_path__ + "static/aboutus2-ace456d40f533933e1f43bb4aa124893.png";